import { useEffect, useState } from 'react';
import { decodeState, isAllowedTenantOrigin } from '../../services/msalConfig';

type CallbackStatus = 'loading' | 'error' | 'success';

const CALLBACK_MESSAGE_TYPE = 'MICROSOFT_AUTH_RESULT';

const MsalCallbackTarget = () => {
  const [status, setStatus] = useState<CallbackStatus>('loading');
  const [message, setMessage] = useState('Processando autenticação Microsoft...');

  useEffect(() => {
    document.title = 'Bluelt | Autenticação Microsoft';

    const finishWithError = (errorMessage: string, tenantOrigin?: string | null) => {
      if (window.opener && tenantOrigin) {
        window.opener.postMessage(
          {
            type: CALLBACK_MESSAGE_TYPE,
            ok: false,
            error: errorMessage,
            timestamp: Date.now(),
          },
          tenantOrigin
        );
      }
      setStatus('error');
      setMessage(errorMessage);
    };

    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const idToken = hashParams.get('id_token');
    const stateParam = hashParams.get('state');
    const oauthError = hashParams.get('error');
    const oauthErrorDescription = hashParams.get('error_description');

    if (!window.opener) {
      finishWithError('Janela de origem não encontrada. Feche e tente novamente.');
      return;
    }

    if (!stateParam) {
      finishWithError('Parâmetro state ausente no retorno Microsoft.');
      return;
    }

    const decodedState = decodeState(stateParam);
    if (!decodedState || !isAllowedTenantOrigin(decodedState.tenantOrigin)) {
      finishWithError('Origem do tenant inválida no retorno Microsoft.');
      return;
    }
    if (Date.now() - decodedState.timestamp > 10 * 60 * 1000) {
      finishWithError('Retorno Microsoft expirado. Inicie o login novamente.', decodedState.tenantOrigin);
      return;
    }

    if (oauthError) {
      finishWithError(oauthErrorDescription || oauthError, decodedState.tenantOrigin);
      return;
    }

    if (!idToken) {
      finishWithError('ID Token não retornado pela Microsoft.', decodedState.tenantOrigin);
      return;
    }

    window.opener.postMessage(
      {
        type: CALLBACK_MESSAGE_TYPE,
        ok: true,
        idToken,
        timestamp: Date.now(),
      },
      decodedState.tenantOrigin
    );

    setStatus('success');
    setMessage('Autenticação concluída. Esta janela será fechada.');
    window.setTimeout(() => {
      window.close();
    }, 300);
  }, []);

  return (
    <div className="auth-container" style={{ minWidth: '320px', maxWidth: '460px', margin: '2rem auto' }}>
      <h3>Microsoft Entra ID</h3>
      <p>{message}</p>
      {status === 'loading' && <div className="spinner" style={{ margin: '1rem auto' }}></div>}
    </div>
  );
};

export default MsalCallbackTarget;
